import React, {Component} from 'react';
import './index.css'

export default class LoginPasswordInput extends Component {
    constructor(props) {
        super(props);
        this.state={
            showClear:false,
            showPassword:false,
            showPasswordType:false,
            value:''
        }
    }

    changeValue = (event) =>{
        const val = event.target.value
        if(val!==''){
            this.setState({showClear:true,showPassword:true})
        }else{
            this.setState({showClear:false,showPassword:false})
        }
        this.setState({value:val})
    }

    componentDidMount() {
        this.props.getValue && this.props.getValue(this)
    }

    getValue = () =>{
        const {value} = this.state;
        return {value}
    }

    changePasswordType = () =>{
        this.setState({
            showPasswordType : !this.state.showPasswordType
        })
    }

    clearInputValue = (event) =>{
        event.target.previousSibling.value="";
        event.target.parentNode.classList.remove('phone')
        this.setState({showClear:false,value:"",showPassword:false})
    }
    render() {
        const {showClear, showPassword, showPasswordType} = this.state
        const {error} = this.props
        return (
            <div className="LoginPasswordInput">
                <input className={error ? "error-input" : ""} maxLength="18" onChange={this.changeValue} type={showPasswordType ? "text" : "password"} placeholder={React.language('query.pass.type')}/>
                {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close"/>}
                {showPassword && <i onClick={this.changePasswordType} className={showPasswordType ? "changePasswordType icon-bsy-filter-show" : "changePasswordType icon-bsy-filter-hide"}/>}
            </div>
        );
    }
}